<script lang="ts">
	/**
	 * The store page while the catalogue loads: a family masthead over a ladder of tier cards, in
	 * the grid `TierLadder` draws (`md:grid-cols-2 xl:grid-cols-3`), so nothing moves sideways when
	 * the real cards land — only the grey turns into words.
	 */
	import Bone from './Bone.svelte';

	export let families: number = 2;
	export let tiers: number = 3;
</script>

<div role="status" aria-label="Loading the catalogue" class="space-y-12 animate-pulse">
	{#each Array(families) as _family, familyIndex (familyIndex)}
		<section>
			<div class="flex flex-wrap items-start gap-4 mb-5">
				<Bone class="w-14 h-14 shrink-0" round="xl" />
				<div class="grow space-y-3">
					<Bone class="h-7 w-48" />
					<Bone class="h-3 w-2/3 max-w-xl" />
				</div>
			</div>
			<div class="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
				{#each Array(tiers) as _tier, tierIndex (tierIndex)}
					<div class="widget bg-depth space-y-4 border-t-4 border-gray-300 dark:border-gray-700">
						<Bone class="h-5 w-1/2" />
						<Bone class="h-3 w-3/4" />
						<Bone class="h-8 w-1/3" />
						<div class="space-y-2">
							<Bone class="h-2.5 w-11/12" />
							<Bone class="h-2.5 w-10/12" />
							<Bone class="h-2.5 w-9/12" />
							<Bone class="h-2.5 w-8/12" />
						</div>
						<Bone class="h-9 w-full" round="xl" />
					</div>
				{/each}
			</div>
		</section>
	{/each}
	<span class="sr-only">Loading…</span>
</div>
